import dynamic from 'next/dynamic';
import { useCallback, useState } from 'react';

import { Modal } from '~components/Modals/Base';

import type { ReportModalProps } from '../../model/types';

const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const ReportModal = ({
	open,
	locked,
	reportCommentRequired,
	onClose,
	...props
}: ReportModalProps) => {
	const [selectedCategory, setSelectedCategory] = useState<
		string | undefined
	>();
	const [reportComment, setReportComment] = useState<string | undefined>();
	const closeWindowAndReset = useCallback(() => {
		setSelectedCategory(undefined);
		setReportComment(undefined);
		onClose();
	}, [onClose]);
	return (
		<Modal open={open} onClose={closeWindowAndReset} locked={locked}>
			<Content
				open={open}
				onClose={closeWindowAndReset}
				locked={locked}
				selectedCategory={selectedCategory}
				reportComment={reportComment}
				setReportComment={setReportComment}
				reportCommentRequired={reportCommentRequired}
				setSelectedCategory={setSelectedCategory}
				{...props}
			/>
		</Modal>
	);
};
